import React from 'react'
import styled from 'styled-components'
import { Col, Form, Row } from 'antd'
import LPHeader from 'src/components/layout/Header/LPHeader'
import StepsHeader from 'src/components/layout/Header/StepHeader'
import { HeaderStyle } from 'src/components/layout/Header/HeaderStyle'
import ButtonCustom from 'src/components/form/Button'
import { InputField } from 'src/components/form'
import { useSMSInputForm, SMSInputFormValues } from './useSMSInputForm'
import phoneLockIcon from 'src/assets/icons/phone_only.svg'
import DuplicateAccountModal from 'src/components/Modal/DuplicateAccountModal'

const SMSInputContainer: React.FC = () => {
  const {
    form,
    onSubmit,
    handleBlur,
    handlePhoneChange,
    hasPhoneDuplicateError,
    isDuplicateModalOpen,
    setIsDuplicateModalOpen,
    duplicatePhone,
    duplicateContactName,
    duplicateContactEmail,
  } = useSMSInputForm()
  const { control, handleSubmit, formState } = form

  return (
    <>
      <LPHeader />
      <div className="w-full justify-center mx-auto register-form layout-webview-step">
        <StepsHeader
          step={10}
          stepActiveName={'基本情報入力'}
          className="top-70"
        />

        <HeaderStyle>ご本人様確認（SMS認証）</HeaderStyle>

        <ContentWrapper>
          <div className="icon-container">
            <img src={phoneLockIcon} alt="SMS認証" />
          </div>
          <h2 className="subtitle">SMS認証</h2>
          <p className="description">
            認証コードを受信できる
            <br />
            携帯電話番号を入力してください。
          </p>

          <StyleForm>
            <Row className="mb-10">
              <label className="mb-10">携帯電話番号</label>
              <Col xs={24}>
                <InputField<SMSInputFormValues>
                  controller={{
                    control,
                    name: 'phone',
                  }}
                  inputProps={{
                    placeholder: '09012345678',
                    type: 'tel',
                    maxLength: 11,
                    onChange: handlePhoneChange,
                    onBlur: (e: React.FocusEvent<HTMLInputElement>) =>
                      handleBlur(e.target.value),
                  }}
                />
              </Col>
            </Row>

            <div className="hints">
              <p>※ハイフン抜きでご入力ください。</p>
              <p>※緊急時など、医師等からご連絡する場合がございます</p>
            </div>

            <ButtonCustom
              className="btn-default btn-chestnut-rose mt-30"
              loading={formState.isSubmitting}
              disabled={hasPhoneDuplicateError || !formState.isValid}
              onClick={handleSubmit(onSubmit)}
              name="携帯に認証コードを送信する"
            />
          </StyleForm>
        </ContentWrapper>
      </div>

      <DuplicateAccountModal
        open={isDuplicateModalOpen}
        onClose={() => setIsDuplicateModalOpen(false)}
        type="phone"
        value={duplicatePhone}
        name={duplicateContactName}
        contactEmail={duplicateContactEmail}
      />
    </>
  )
}

const ContentWrapper = styled.div`
  text-align: center;
  padding: 20px;

  .icon-container {
    margin-bottom: 20px;
  }

  .subtitle {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 15px;
  }

  .description {
    font-size: 14px;
    line-height: 1.6;
    margin-bottom: 30px;
  }

  .hints {
    text-align: left;
    font-size: 12px;
    color: #666;
    margin-top: 5px;
    p {
      margin-bottom: 2px;
    }
  }
`

const StyleForm = styled(Form)``

export default SMSInputContainer
